export const UPDATE_PROCESS_STATEMENT_COMMENT_SUCCESS = 'UPDATE_PROCESS_STATEMENT_COMMENT_SUCCESS';

export const updateProcessStatementCommentSuccess = processStatement => ({
    type: UPDATE_PROCESS_STATEMENT_COMMENT_SUCCESS,
    payload: { processStatement },
});
